module.exports = __webpack_public_path__ + "static/media/Players.dde4f1a7.jpeg";